__turbopack_context__.v({
  "backBtn": "styles-module-scss-module__BxwbIa__backBtn",
  "btnGroup": "styles-module-scss-module__BxwbIa__btnGroup",
  "clear": "styles-module-scss-module__BxwbIa__clear",
  "filterContainer": "styles-module-scss-module__BxwbIa__filterContainer",
  "filterLogo": "styles-module-scss-module__BxwbIa__filterLogo",
  "filterTitle": "styles-module-scss-module__BxwbIa__filterTitle",
  "filterType": "styles-module-scss-module__BxwbIa__filterType",
  "highlightedBtn": "styles-module-scss-module__BxwbIa__highlightedBtn",
});
